"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_STAKING_INFO = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.ALL_STAKING_INFO = graphql_tag_1.default `
query allStakingInfo {
  multiTokenStakings(first: 1) {
    id
    owner
    rewardsSchedule
    startBlock
    endBlock
    rewardsToken
    totalAllocPoint
    poolCount
    pools(first: 100) {
      id
      symbol
      name
      decimals
      balance
      isPairToken
      allocPoint
      lastRewardBlock
      userCount
      updatedAt
    }
  }
}
`;
